module.exports = __webpack_public_path__ + "media/images/lb/934-1a34c633e467b0a08e8c0bb89e1f60ae.svg";